import { createStore, Store } from 'vuex';
import BaseMapStylesDialogModule, {
  BaseMapStylesState
} from '../../base_map_dialog/store/modules/BaseMapStylesDialogModule';

export interface RootState {
  mapStyles: BaseMapStylesState;
}

const store: Store<RootState> = createStore({
  modules: {
    mapStyles: BaseMapStylesDialogModule,
  }
});

export default store;
